import Constant from "./isomorphismConstant";

export enum Platform {
	WEB = "web",
	MWEB = "mweb",
}

export const isPC = () => {
	return Constant.platform === Platform.WEB;
};
